// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__3KwlB","pageContent":"page_pageContent__gC1BE","mainContent":"page_mainContent__359wq"};